import { useTranslation } from 'react-i18next';

import { PageLayout } from '../../../layouts/page-layout/page-layout';

import { CodeCaptureForm } from './code-capture-form';

const VerificationCodeStep = ({
  deliveryAddress,
  onSubmit,
  onResend,
}: {
  readonly deliveryAddress: string;
  readonly onSubmit: (code: string) => Promise<void>;
  readonly onResend: () => void | Promise<void>;
}) => {
  const { t } = useTranslation();
  return (
    <PageLayout title={t('auth.accountVerification.code.title')}>
      <CodeCaptureForm
        autoComplete="one-time-code"
        buttonLabel={t('common.buttons.submit')}
        description={t('auth.accountVerification.code.sent', { to: deliveryAddress })}
        errorRequired={t('auth.common.errors.confirmationCodeMissing')}
        inputMode="numeric"
        onRetry={onResend}
        onSubmit={onSubmit}
        placeholder={'000000'}
        showSupportContact
      />
    </PageLayout>
  );
};

export { VerificationCodeStep };
